<template>

<v-app-bar
  dark fixed
  color="primary"
  max-height="60"
>
    <!-- <v-btn href="/" text left> -->
    <v-img style="cursor:pointer"
      alt="Every Formula Logo"
      class="shrink mr-2"
      contain
      src="../assets/logo.png"
      transition="scale-transition"
      width="40"
      @click="goHome"
    />
    <v-toolbar-title id="title" class="text-md-h5 mr-2 shrink" style="cursor:pointer" @click="goHome">{{apptitle}}</v-toolbar-title>
    <!-- </v-btn> -->

    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="(item, idx) in menu"
          :key="idx"
          :to="item.link"
          text
      >
        <span>
          <v-icon v-if="item.icon" v-text="item.icon"></v-icon>
        </span>
        <span>{{ item.title }}</span>
      </v-btn>
    </v-toolbar-items>

    <v-menu>
      <template v-slot:activator="{ on, attrs }">
      <v-app-bar-nav-icon  class="hidden-md-and-up"
          v-bind="attrs"
          v-on="on"
      ></v-app-bar-nav-icon>
      </template>
      <v-list>
          <v-list-item v-for="(item, idx) in menu" :key="idx" :to="item.link" exact>
          <v-list-item-icon v-if="item.icon">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>   
      </v-list>
    </v-menu>
    
</v-app-bar>

  
</template>

<script>
export default {
  data () {
    return {
      apptitle: "Every Formula",
      item: 1,
      menu: [
        { title: 'Search', link: "/search", icon: null },
        { title: 'CoWord-Net', link: "/co-net", icon: null },
        { title: 'Semantic-MAP', link: "/wv-net", icon: null },
        { title: 'About', link: "/about", icon: null },
      ]
    }
  },
  methods: {
    goHome () {
      window.location = "/"
    }
  },

}
</script>

<style scoped>
#title { 
  text-transform: none !important; 
} 
</style>